<template>
  <div class="light">
    <div class="header">
      <div class="title">灯具设备列表</div>
      <div class="fast-btn">
        <dtit-button :is-cover="groupInfo['isCovers']" :state="groupInfo['state']" class="addgroup" :text="groupInfo['text']" :type="groupInfo['type']" :is-cancel="groupInfo['isCancel']" :icon-url="groupInfo['iconUrl']" @change="group" @cancel="cancel" @save="save"/>
        <my-button :state="state" @change="powerSwitch" v-if="groupInfo['iconUrl']"></my-button>
        <template v-if="groupInfo['iconUrl']">
          <el-dropdown type="primary" @command="changeBR" trigger="click" v-if="zone && zone.enableBR===1">
            <el-button type="primary">
              调节亮度<i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(br,i) in brArray" :command="br.value"
                                v-text="br.name"
                                :key="`br_${i}`"></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown type="primary" @command="changeCCT" trigger="click" v-if="zone && zone.enableCCT===1">
            <el-button type="primary">
              调节色温<i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(cct,i) in cctArray" :command="`${cct.value}`"
                                v-text="cct.name"
                                :key="`cct_${i}`"></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
    <div class="container">
      <div class="group-device"  v-for="(d,i) in lights" :key="`light_d_${i}`">
        <light :device="d"></light>
        <div class="group-edit" v-if="isCover && d.device_node_type !== 39"></div>
        <div class="group-checkbox" v-if="isCover && d.device_node_type !== 39" :class="{checked: d.checked, unchecked: !d.checked}" @click="choose(d, i)"></div>
      </div>
      <spot-light :device="d"
                  v-for="(d,i) in extDevices.filter(ext=>ext.devicetype.key==='switch' && ext.name.indexOf('射灯')>-1)"
                  :key="`spot_light_${i}`"></spot-light>
      <colorbar :device="d"
                v-for="(d,i) in extDevices.filter(ext=>ext.devicetype.key==='colorbar')"
                :key="`color_light_${i}`"></colorbar>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import Light from '@/components/Light'
import Round from '@/components/Round'
import SpotLight from '@/components/Switch'
import MyButton from '@/components/Button'
import DtitButton from '@/components/DtitButton'
import Colorbar from '@/components/Colorbar'
import config from '@/model/config'
import { mapState, mapActions } from 'vuex'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  name: 'DeviceLight',
  data () {
    return {
      // state: false,
      brArray: [],
      cctArray: [],
      isCover: false,
      groupInfo: {
        text: '添加群控',
        type: 'light',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      },
      name: '',
      index: '',
      desc: ''
    }
  },
  provide () {
    return {
      all: this
    }
  },
  computed: {
    ...mapState(['lights', 'extDevices', 'zone', 'groups']),
    state () {
      return this.lights.every(l => l.state)
    }
  },
  async created () {
    try {
      const data = await config.get(['brSplit', 'cctSplit'])
      if (data.data.rows.length) {
        this.brArray = []
        this.cctArray = []
        data.data.rows.forEach(r => {
          const item = { name: r.value.split(',')[0], value: parseInt(r.value.split(',')[1]) }
          if (r.name === 'cctSplit') {
            this.cctArray.push(item)
          } else {
            this.brArray.push(item)
          }
        })
      }
    } catch (e) {
      Message.error(e.message)
    }
  },
  components: {
    Colorbar,
    MyButton,
    SpotLight,
    Light,
    Round,
    DtitButton
  },
  methods: {
    ...mapActions(['updateGroups']),
    async powerSwitch () {
      try {
        await api.batchControl(['light', 'colorbar', 'spotlight'], this.state ? 'close' : 'open')
        // this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeBR (value) {
      try {
        await api.batchControl(['light'], 'br', value)
        this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeCCT (value) {
      try {
        await api.batchControl(['light'], 'cct', value)
        this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    // 群组功能
    group () {
      if (!this.groupInfo['state']) {
        this.isCover = true
        this.groupInfo = {
          text: '保存',
          type: 'light',
          iconUrl: '',
          state: false,
          isCancel: true,
          isCovers: false
        }
      }
      // 保存选中的设备
      if (this.groupInfo['state']) {

      }
    },
    // 取消
    cancel () {
      this.isCover = false
      this.groupInfo = {
        text: '添加群控',
        type: 'light',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      }
      this.lights.forEach((item, index) => {
        item.checked = false
        this.$set(this.lights, index, item)
      })
      this.name = ''
      this.desc = ''
      this.index = ''
    },
    // 选中分组设备
    choose (item, index) {
      item.checked = !item.checked
      this.$set(this.lights, index, item)
      // 检查是否又被选中的设备
      const isChecked = this.lights.some(item => item.checked)
      this.groupInfo['state'] = isChecked
    },
    // 保存组
    async save (data) {
      let listId = this.lights.filter(item => item.checked).map(item => item.id)
      // 如果是修改
      if (this.groupInfo.isCovers) {
        this.groups[this.index]['name'] = data.name
        this.groups[this.index]['remark'] = data.desc
        let result = await this.updateGroups(this.groups)
        if (result && result.code === 1) {
          Message.success('修改成功！')
        } else {
          Message.warning('修改失败！')
        }
      } else {
        let result = await this.updateGroups({ name: data.name, remark: data.desc, key: 'light', listId })
        if (result && result.code === 1) {
          Message.success('添加成功！')
        } else {
          Message.warning('添加失败！')
        }
      }
    }
  },
  activated () {
    // 处理修改组控
    if (this.$route.params && this.$route.params['include']) {
      this.name = this.$route.params['name']
      this.index = this.$route.params['index']
      this.desc = this.$route.params['desc']
      this.isCover = true
      this.groupInfo = {
        text: '保存',
        type: 'light',
        iconUrl: '',
        state: true,
        isCancel: true,
        isCovers: true
      }
      // 判断选中
      this.lights.forEach((item, index) => {
        if (this.$route.params['include'].includes(item.id)) {
          item.checked = true
          this.$set(this.lights, index, item)
        }
      })
    } else {
      this.cancel()
    }
  },
  mounted () {
    this.cancel()
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";
.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
    > .group-device {
      position: relative;
      box-sizing: border-box;
      height: 260px;
      min-width: 230px;
      max-width: 24%;
      .group-edit {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.2;
      }
      .group-checkbox {
        position: absolute;
        bottom: 24px;
        right: 24px;
        width: 30px;
        height: 30px;
        z-index: 1;
      }
      .unchecked {
          background: url('../../assets/images/group/unchecked.png') no-repeat center;
          background-size:cover;
      }
      .checked {
          background: url('../../assets/images/group/checked.png') no-repeat center;
          background-size:cover;
      }
    }
  }
}
</style>
